import $ from '@modules/jquery-import';
import {jqueryJiggle} from '@modules/lazy-imports';

$.fn.upiDialog = async function ( msg, callbacks, opt ) {
    await jqueryJiggle();

    var defaults = {
        type: 'modal' // modal | inline
    };
    opt = $.extend( defaults, opt );

    return $( this ).each( function () {
        var target = $( this ),
            dialog, delegate_selector;

        switch ( opt.type ) {
            case 'inline':
                dialog = $( '<div class="dialog-inline"></div>' )
                    .append( $( '<p />' ).text( msg ) )
                    .append( $( '<i class="indicator"></i>' ) )
                    .append( get_actions() );

                // add dialog to DOM and position it
                var pos = $( this ).position();
                dialog.insertAfter( this );
                // TODO: need global method for smart positioning
                dialog.css( {
                    top: (pos.top + parseInt( this.offsetHeight / 2 )) - parseInt( dialog[0].offsetHeight / 2 ),
                    left: pos.left + this.offsetWidth + 5
                } );
                break;

            default:
                var dialog_wrapper, dialog_body;

                // if a dialog is already open, alert user and cancel dialog creation
                if ( (dialog_wrapper = $( '#upi-dialog-wrapper' ))[0] ) {
                    dialog_wrapper.jiggle();
                    return false;
                }

                dialog_body = $( '<div class="upi-dialog-content"></div>' );
                dialog_body.append( $( '<p />' ).addClass( opt.className || '' ).text( msg ) );

                dialog_wrapper = $( '<div id="upi-dialog-wrapper"></div>' )
                    .append( dialog_body )
                    .append( $( '<div class="upi-dialog-ft"></div>' ).append( get_actions() ) );

                dialog = $( '<div id="upi-dialog"></div>' )
                    .append( dialog_wrapper );

                $( 'body' ).prepend( dialog );
        }

        dialog
            .find( '.button[class^="dialog-"]:first' ).focus() /* give focus to first button */
            .show();

        // bind events in separate thread than current event in bubble phase
        // otherwise bubbled event will trigger dialog to close immediately
        setTimeout( function () {
            // if modal window: only allow dialog button to close layer
            delegate_selector = (opt.type === 'modal') ? ' .button[class*="dialog-"] ' : 'body';
            $( document ).on( 'click keypress', delegate_selector, handle_dialog_action );
        }, 0 );

        function handle_dialog_action ( e ) {
            if ( 'keypress' === e.type && e.which !== 13 ) {
                return;
            }
            // if target has a className that contains dialog- extract action from
            //  dialog button eg. dialog-confirm => confirm and execute callback else destroy
            var action = /\bdialog-([a-zA-Z0-9\-]+)\b/.exec( e.target.className );
            action = (action) ? action[1].replace( /\-/g, ' ' ) : null;
            if ( typeof callbacks[action] == 'function' ) {
                callbacks[action]();
            }
            destroy();
        };

        function get_actions () {
            var actions = '';
            for ( var action in callbacks ) {
                if ( action !== 'complete' ) {
                    actions +=
                        '<span tabindex="1" class="dialog-' +
                        action.replace( / /g, '-' ) +
                        ' button secondary">' +
                        action +
                        '</span>';
                }
            }
            return actions;
        };

        function destroy ( e ) {
            var cleanup = callbacks['complete'];
            if ( typeof cleanup == 'function' ) {
                cleanup();
            }

            dialog.fadeOut( 200, function () {
                dialog.remove();
            } );
            $( document ).off( 'click keypress', delegate_selector, handle_dialog_action );
        };

    } );
};
